import { ColorMode } from '@revolut-internal/ui-kit'

import { useDarkMode } from './useDarkMode'

export function useLayoutProvider() {
  const { isDarkMode, toggle: toggleThemeMode } = useDarkMode()

  const themeMode: ColorMode = isDarkMode ? ColorMode.DARK : ColorMode.LIGHT

  return {
    themeMode,
    toggleThemeMode,
  }
}
